export default "__VITE_ASSET__yisqU4Q0__"